import { Service } from '@angular/core';
import { replaceThamDomainWithProxyCdn } from '@thiememeulenhoff/js-sdk';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ThamConfig } from './tham.const';

@Service()
export class ThamService {
  private static config?: ThamConfig;

  #accessToken = new BehaviorSubject<string | null>(null);

  static init(config: ThamConfig) {
    if (!ThamService.config) {
      ThamService.config = config;
    }
  }

  get proxyDomain() {
    return ThamService.config?.cdnDomain;
  }

  get accessToken() {
    return this.#accessToken.value;
  }

  set accessToken(token: string | null) {
    this.#accessToken.next(token);
  }

  replaceThamDomainWithProxyCdn(content: string | null | undefined): string {
    if (!this.proxyDomain || !this.accessToken) {
      return content ?? '';
    }

    return replaceThamDomainWithProxyCdn(
      content ?? '',
      this.accessToken,
      this.proxyDomain,
    );
  }

  replaceThamDomainWithProxyCdn$(
    content: string | null | undefined,
  ): Observable<string> {
    return this.#accessToken
      .asObservable()
      .pipe(map(() => this.replaceThamDomainWithProxyCdn(content)));
  }
}
